var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"router"}},[_c('router-view',{key:_vm.$route.path})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }